import { render, staticRenderFns } from "./com-table.vue?vue&type=template&id=3d900fb0&scoped=true&"
import script from "./com-table.vue?vue&type=script&lang=js&"
export * from "./com-table.vue?vue&type=script&lang=js&"
import style0 from "./com-table.vue?vue&type=style&index=0&id=3d900fb0&prod&lang=scss&scoped=true&"
import style1 from "./com-table.vue?vue&type=style&index=1&id=3d900fb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d900fb0",
  null
  
)

export default component.exports